import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import ModalAgendamento from '../../components/ModalAgendamento';
import { formatDate } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
  GlobalStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Chip,
  Alert,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { useTheme as useAppTheme } from '../../context/ThemeContext';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PersonIcon from '@mui/icons-material/Person';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';
import GoogleIcon from '@mui/icons-material/Google';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import ModalPagamento from '../../components/ModalPagamento';
import { useAuth } from '../../context/AuthContext';
import ModalAnamnese from '../../components/ModalAnamnese';
import { criarFaturamento } from '../../services/faturamentoService';
import api from '../../services/api';
import FullCalendar from "@fullcalendar/react";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";

// Usa variável de ambiente para alternar entre local e produção
const BASE_API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const API_URL = `${BASE_API_URL}/agendamentos`;
const API_PACIENTES = `${BASE_API_URL}/pacientes`;
const API_PROCEDIMENTOS = `${BASE_API_URL}/procedimentos`;

const Calendar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const calendarRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:768px)');
  const { isDarkMode } = useAppTheme();
  const { user } = useAuth();
  const tipoUsuario = user?.tipoPessoa || 'PF';

  // Função utilitária para estilos do status
  function getStatusStyles(status) {
    if (status === "confirmado") {
      return {
        backgroundColor: "rgb(2, 114, 29)",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: 0,
        paddingBottom: 0,
        margin: "10px 0",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        textAlign: "left",
        width: "100%",
      };
    }
    if (status === "cancelado") {
      return {
        backgroundColor: "rgb(188, 11, 52)",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: 0,
        paddingBottom: 0,
        margin: "10px 0",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        textAlign: "left",
        width: "100%",
      };
    }
    // Azul padrão para outros status
    return {
      backgroundColor: "#19349d",
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: 0,
      paddingBottom: 0,
      margin: "10px 0",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      textAlign: "left",
      width: "100%",
    };
  }
  const [currentEvents, setCurrentEvents] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    paciente_id: "",
    procedimento_id: "",
    data_hora: "",
    duracao_minutos: 30,
    observacoes: ""
  });
  const [avaliacaoId, setAvaliacaoId] = useState("");
  // Orçamento fechado do paciente, usado só pra pré-preencher o valor negociado
  // quando o pagamento é lançado a partir de "Compareceu" (ver handleLancamentoFeito)
  const [orcamentoData, setOrcamentoData] = useState(null);
  const [pagamentoOpen, setPagamentoOpen] = useState(false);
  const [pagamentoData, setPagamentoData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [pacientes, setPacientes] = useState([]);
  const [procedimentos, setProcedimentos] = useState([]);
  const [anamneseOpen, setAnamneseOpen] = useState(false);
  const [pacienteAnamnese, setPacienteAnamnese] = useState(null);
  const [detalheOpen, setDetalheOpen] = useState(false);
  const [detalheEvento, setDetalheEvento] = useState(null);
  const [detalheLoading, setDetalheLoading] = useState(false);
  const [promptLancamento, setPromptLancamento] = useState(false);
  const [lancamentoAgendamentoId, setLancamentoAgendamentoId] = useState(null);
  const [dentistas, setDentistas] = useState([]);
  const [filtroDentista, setFiltroDentista] = useState('todos');
  const [editandoId, setEditandoId] = useState(null);
  // Orçamento que originou o agendamento em criação, quando veio da ficha do
  // paciente ("Orçamento fechado! Quer marcar a consulta agora?")
  const [orcamentoIdPendente, setOrcamentoIdPendente] = useState(null);
  const [bloqueios, setBloqueios] = useState([]);
  const [confirmDesbloqueio, setConfirmDesbloqueio] = useState(null);
  const [avisoDialog, setAvisoDialog] = useState({ open: false, titulo: '', mensagem: '' });

  const mostrarAviso = (mensagem, titulo = 'Não foi possível concluir') => {
    setAvisoDialog({ open: true, titulo, mensagem });
  };

  // Integração Google Calendar
  const [googleConectado, setGoogleConectado] = useState(null); // null = carregando
  const [googleCarregando, setGoogleCarregando] = useState(false);
  const [googleAviso, setGoogleAviso] = useState('');
  const [eventosGoogleExternos, setEventosGoogleExternos] = useState([]);
  const [sincronizandoGoogle, setSincronizandoGoogle] = useState(false);

  // Exemplo de como obter o token do localStorage
  const token = localStorage.getItem('token');

  const carregarBloqueios = () => {
    api.get('/bloqueios').then(data => {
      setBloqueios(Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : []);
    }).catch(() => {});
  };

  useEffect(() => { carregarBloqueios(); }, []);

  // Veio da ficha do paciente depois de fechar um orçamento ("Quer marcar a
  // consulta agora?") — abre o modal de novo agendamento já com paciente e
  // procedimentos preenchidos, e guarda o orçamento pra linkar ao salvar.
  useEffect(() => {
    const novoAgendamento = location.state?.novoAgendamento;
    if (!novoAgendamento) return;
    setModalData(prev => ({
      ...prev,
      paciente_id: novoAgendamento.pacienteId || '',
      procedimentos: novoAgendamento.procedimentos || [],
      procedimento_id: novoAgendamento.procedimentos?.[0] || '',
      data_hora: '',
      observacoes: '',
    }));
    setOrcamentoIdPendente(novoAgendamento.orcamentoId || null);
    setEditandoId(null);
    setModalOpen(true);
    // Limpa o state pra não reabrir o modal de novo se o usuário navegar por aqui de novo
    navigate(location.pathname, { replace: true, state: {} });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // Verifica status da conexão com o Google Calendar e trata o retorno do OAuth (?google=conectado|erro)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const resultado = params.get('google');
    if (resultado) {
      setGoogleAviso(resultado === 'conectado' ? 'Google Calendar conectado com sucesso!' : 'Não foi possível conectar ao Google Calendar. Tente novamente.');
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(() => setGoogleAviso(''), 5000);
    }

    api.get('/google/status')
      .then(data => setGoogleConectado(!!data?.conectado))
      .catch(() => setGoogleConectado(false));
  }, []);

  const handleConectarGoogle = async () => {
    setGoogleCarregando(true);
    try {
      const data = await api.get('/google/connect-url');
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      setGoogleAviso('Erro ao iniciar conexão com o Google. Tente novamente.');
      setTimeout(() => setGoogleAviso(''), 5000);
    } finally {
      setGoogleCarregando(false);
    }
  };

  const handleDesconectarGoogle = async () => {
    setGoogleCarregando(true);
    try {
      await api.post('/google/disconnect');
      setGoogleConectado(false);
      setEventosGoogleExternos([]);
      setGoogleAviso('Google Calendar desconectado.');
      setTimeout(() => setGoogleAviso(''), 4000);
    } catch (err) {
      setGoogleAviso('Erro ao desconectar. Tente novamente.');
      setTimeout(() => setGoogleAviso(''), 5000);
    } finally {
      setGoogleCarregando(false);
    }
  };

  const handleSincronizarGoogle = async () => {
    setSincronizandoGoogle(true);
    try {
      const eventos = await api.get('/google/eventos-externos');
      const mapeados = (Array.isArray(eventos) ? eventos : []).map(ev => ({
        id: `google-${ev.id}`,
        title: ev.titulo,
        start: ev.inicio,
        end: ev.fim,
        allDay: ev.diaTodo,
        editable: false,
        backgroundColor: '#9CA3AF',
        borderColor: '#9CA3AF',
        extendedProps: { externo: true, user_id: user?.id },
      }));
      setEventosGoogleExternos(mapeados);
      setGoogleAviso(mapeados.length > 0 ? `${mapeados.length} compromisso(s) pessoal(is) importado(s) do Google.` : 'Nenhum compromisso pessoal novo encontrado no Google.');
      setTimeout(() => setGoogleAviso(''), 4000);
    } catch (err) {
      setGoogleAviso('Erro ao sincronizar com o Google Calendar.');
      setTimeout(() => setGoogleAviso(''), 5000);
    } finally {
      setSincronizandoGoogle(false);
    }
  };

  useEffect(() => {
    fetch(API_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) {
          console.error('API retornou um formato inesperado:', data);
          return;
        }
        // Monta o título juntando o nome de TODOS os procedimentos do
        // agendamento (não só o primeiro) — com fallback pro procedimento_id
        // único de agendamentos antigos, criados antes de suportar vários.
        const events = data.map(ag => {
          const idsProcedimentos = Array.isArray(ag.procedimentos) && ag.procedimentos.length
            ? ag.procedimentos
            : (ag.procedimento_id ? [ag.procedimento_id] : []);
          const procedimentoNome = idsProcedimentos.map(pid => {
            if (ag.procedimento?.id === pid) return ag.procedimento.nome;
            return procedimentos.find(p => p.id === pid)?.nome;
          }).filter(Boolean).join(', ');
          const pacienteNome = ag.paciente?.nome || '';
          const corDentista = ag.usuario?.cor || null;
          return {
            id: ag.id || ag._id,
            title: `${pacienteNome ? pacienteNome + (procedimentoNome ? ' - ' + procedimentoNome : '') : ag.status + (procedimentoNome ? ' - ' + procedimentoNome : '')}${ag.observacoes ? ' - ' + ag.observacoes : ''}`,
            start: ag.data_hora,
            end: ag.data_hora,
            allDay: false,
            backgroundColor: corDentista || undefined,
            borderColor: corDentista || undefined,
            extendedProps: {
              paciente_id: ag.paciente_id,
              procedimento_id: ag.procedimento_id,
              procedimentos: idsProcedimentos,
              procedimento_nome: procedimentoNome,
              duracao_minutos: ag.duracao_minutos,
              observacoes: ag.observacoes,
              status: ag.status,
              lancamento_feito: ag.lancamento_feito || false,
              cor_dentista: corDentista,
              nome_dentista: ag.usuario?.nome || '',
              user_id: ag.user_id,
            }
          };
        });
        setCurrentEvents(events);
      })
      .catch(err => {
        console.error('Erro ao buscar agendamentos:', err);
      });
    // Buscar pacientes
    fetch(`${API_PACIENTES}?limit=9999`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        const lista = Array.isArray(data) ? data : data?.pacientes || [];
        setPacientes(lista);
      });
    // Buscar procedimentos
    fetch(API_PROCEDIMENTOS, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setProcedimentos(data);
          // Busca o procedimento "Avaliação" e salva o id
          const avaliacao = data.find(p => p.nome.toLowerCase().includes("avaliação"));
          if (avaliacao) setAvaliacaoId(avaliacao.id);
        }
      });
    // Buscar dentistas da clínica (dono + parceiros)
    const usuarioLogado = JSON.parse(localStorage.getItem('user') || '{}');
    const listaDentistas = [{ id: usuarioLogado.id, nome: usuarioLogado.nome || 'Eu', cor: null }];
    fetch(`${BASE_API_URL}/secretarias/dentistas-clinica`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.json())
      .then(data => {
        const outros = (data.dentistas || []).filter(u => u.id !== usuarioLogado.id);
        setDentistas([...listaDentistas, ...outros]);
      })
      .catch(() => setDentistas(listaDentistas));
  }, []);

  const handleDateClick = (selected) => {
    // dateClick manda .dateStr; select (usado antes) mandava .startStr —
    // aceita os dois formatos pra não quebrar se algum outro lugar ainda
    // chamar isso a moda antiga.
    const dataStr = selected.dateStr || selected.startStr;
    setSelectedDate(dataStr);
    // Preenche a data do modal com o dia clicado
    setModalData({
      paciente_id: "",
      procedimento_id: avaliacaoId,
      data_hora: `${dataStr}T08:00`,
      data: dataStr, // novo campo para passar ao modal
      hora: '08:00',
      duracao_minutos: 30,
      observacoes: ""
    });
    setEditandoId(null);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEditandoId(null);
    setOrcamentoIdPendente(null);
  };

  const minutosParaDuracaoStr = (min) => {
    if (min === 60) return '1h 00min';
    if (min === 90) return '1h 30min';
    if (min === 120) return '2h 00min';
    return '30 min';
  };

  const handleAbrirEdicao = () => {
    if (!detalheEvento) return;
    const dataHora = detalheEvento.start ? new Date(detalheEvento.start) : null;
    setEditandoId(detalheEvento.id);
    setModalData({
      paciente_id: detalheEvento.pacienteId,
      procedimento_id: detalheEvento.procedimentoId,
      procedimentos: detalheEvento.procedimentos?.length ? detalheEvento.procedimentos : (detalheEvento.procedimentoId ? [detalheEvento.procedimentoId] : []),
      data: dataHora ? dataHora.toISOString().slice(0, 10) : '',
      hora: dataHora ? dataHora.toISOString().slice(11, 16) : '',
      duracao_minutos: detalheEvento.duracao,
      observacoes: detalheEvento.observacoes,
      user_id: detalheEvento.dentistaId,
    });
    setDetalheOpen(false);
    setModalOpen(true);
  };

  const handleCriarBloqueio = async (dados) => {
    try {
      await api.post('/bloqueios', dados);
      carregarBloqueios();
    } catch (err) {
      mostrarAviso(err?.response?.data?.error || 'Erro ao bloquear horário.', 'Não foi possível bloquear');
    }
  };

  const handleConfirmarDesbloqueio = async () => {
    if (!confirmDesbloqueio) return;
    try {
      await api.delete(`/bloqueios/${confirmDesbloqueio.id}`);
      setBloqueios(prev => prev.filter(b => b.id !== confirmDesbloqueio.id));
      setConfirmDesbloqueio(null);
    } catch (err) {
      setConfirmDesbloqueio(null);
      mostrarAviso('Erro ao desbloquear horário.', 'Não foi possível desbloquear');
    }
  };

  const formatarPeriodoBloqueio = ({ inicio, fim, diaTodo }) => {
    if (diaTodo) return 'Dia todo';
    const opts = { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' };
    const h1 = inicio ? new Date(inicio).toLocaleTimeString('pt-BR', opts) : '';
    const h2 = fim ? new Date(fim).toLocaleTimeString('pt-BR', opts) : '';
    return h1 && h2 ? `${h1} – ${h2}` : '';
  };

  // Renderização customizada dos eventos do calendário — bloqueios e compromissos
  // externos mostram um ícone de cadeado minimalista + horário sempre visível
  // (em vez de só um título), pra secretária não precisar adivinhar a hora.
  const renderEventContent = (arg) => {
    const props = arg.event.extendedProps || {};
    if (props.bloqueio || props.externo) {
      const periodo = props.bloqueio
        ? formatarPeriodoBloqueio({ inicio: arg.event.start, fim: arg.event.end, diaTodo: arg.event.allDay })
        : (arg.timeText || '');
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden', width: '100%', px: 0.25 }}>
          <LockOutlinedIcon sx={{ fontSize: 12, flexShrink: 0 }} />
          <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {periodo}{periodo && ' · '}{arg.event.title}
          </Typography>
        </Box>
      );
    }
    return (
      <Box sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '100%', px: 0.25 }}>
        {arg.timeText && (
          <Typography component="span" sx={{ fontSize: '0.72rem', fontWeight: 700, mr: 0.5 }}>
            {arg.timeText}
          </Typography>
        )}
        <Typography component="span" sx={{ fontSize: '0.75rem' }}>{arg.event.title}</Typography>
      </Box>
    );
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setModalData(prev => ({ ...prev, [name]: value }));
  };

  const handleModalSubmit = async () => {
    // Envia para a API
    // Recupera o usuário logado do localStorage
    const usuarioLogado = JSON.parse(localStorage.getItem('user'));
    const novoAgendamento = {
      clinica_id: usuarioLogado?.clinicaId || "1", // ajuste conforme necessário
      user_id: usuarioLogado?.id,
      paciente_id: modalData.paciente_id,
      procedimento_id: modalData.procedimento_id,
      data_hora: modalData.data_hora,
      duracao_minutos: modalData.duracao_minutos,
      status: "agendado",
      observacoes: modalData.observacoes
    };
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(novoAgendamento)
      });
      if (res.ok) {
        // Atualiza lista após salvar
        const agendamentoSalvo = await res.json();
        // Busca o nome do procedimento
        let procedimentoNome = '';
        if (agendamentoSalvo.procedimento_id && procedimentos.length > 0) {
          const proc = procedimentos.find(p => p.id === agendamentoSalvo.procedimento_id);
          procedimentoNome = proc ? proc.nome : '';
        }
        setCurrentEvents(prev => ([
          ...prev,
          {
            id: agendamentoSalvo.id,
            title: `${agendamentoSalvo.status}${procedimentoNome ? ' - ' + procedimentoNome : ''}${agendamentoSalvo.observacoes ? ' - ' + agendamentoSalvo.observacoes : ''}`,
            start: agendamentoSalvo.data_hora,
            end: agendamentoSalvo.data_hora,
            allDay: false,
            extendedProps: {
              paciente_id: agendamentoSalvo.paciente_id,
              procedimento_id: agendamentoSalvo.procedimento_id,
              duracao_minutos: agendamentoSalvo.duracao_minutos,
              observacoes: agendamentoSalvo.observacoes,
              status: agendamentoSalvo.status
            }
          }
        ]));
        // Salva o id do agendamento recém-criado para uso no orçamento
        setModalData(prev => ({
          ...prev,
          agendamento_id: agendamentoSalvo.id
        }));
        setModalOpen(false);
      } else {
        alert("Erro ao salvar agendamento!");
      }
    } catch (err) {
      alert("Erro de conexão com o backend!");
    }
  };

  const handleEventClick = (selected) => {
    const evento = selected.event;

    // Compromisso pessoal importado do Google — só leitura, não abre o modal de agendamento
    if (evento.extendedProps?.externo) {
      mostrarAviso(
        `${evento.title}\n${evento.start?.toLocaleString('pt-BR', { timeZone: 'UTC' }) || ''}`,
        'Compromisso pessoal (Google Calendar)'
      );
      return;
    }

    // Horário bloqueado — oferece desbloquear em vez de abrir o modal de agendamento
    if (evento.extendedProps?.bloqueio) {
      setConfirmDesbloqueio({
        id: evento.extendedProps.bloqueioId,
        motivo: evento.extendedProps.motivo,
        inicio: evento.start,
        fim: evento.end,
        diaTodo: evento.allDay,
      });
      return;
    }

    // Abre modal de detalhes
    const ev = selected.event;
    const pacienteId = ev.extendedProps?.paciente_id || ev._def?.extendedProps?.paciente_id || '';
    const paciente = pacientes.find(p => p.id === pacienteId) || null;
    setDetalheEvento({
      id: ev.id,
      title: ev.title,
      start: ev.start,
      paciente,
      pacienteId,
      procedimentoId: ev.extendedProps?.procedimento_id || '',
      procedimentos: ev.extendedProps?.procedimentos || (ev.extendedProps?.procedimento_id ? [ev.extendedProps.procedimento_id] : []),
      duracao: ev.extendedProps?.duracao_minutos || 30,
      observacoes: ev.extendedProps?.observacoes || '',
      status: ev.extendedProps?.status || '',
      lancamentoFeito: ev.extendedProps?.lancamento_feito || false,
      nomeDentista: ev.extendedProps?.nome_dentista || '',
      corDentista: ev.extendedProps?.cor_dentista || null,
      dentistaId: ev.extendedProps?.user_id || '',
      fcEvent: selected.event,
    });
    setDetalheOpen(true);
  };

  const handleDetalheExcluir = async () => {
    if (!detalheEvento) return;
    setDetalheLoading(true);
    try {
      const res = await fetch(`${API_URL}/${detalheEvento.id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        setCurrentEvents(prev => prev.filter(ev => ev.id !== detalheEvento.id));
        detalheEvento.fcEvent.remove();
        setDetalheOpen(false);
      } else {
        alert('Erro ao excluir agendamento!');
      }
    } catch { alert('Erro de conexão!'); }
    setDetalheLoading(false);
  };

  const handleDetalheStatus = async (novoStatus) => {
    if (!detalheEvento) return;
    setDetalheLoading(true);
    try {
      const res = await fetch(`${API_URL}/${detalheEvento.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: novoStatus })
      });
      if (res.ok) {
        setCurrentEvents(prev => prev.map(ev =>
          ev.id === detalheEvento.id ? { ...ev, extendedProps: { ...ev.extendedProps, status: novoStatus } } : ev
        ));
        setDetalheEvento(prev => ({ ...prev, status: novoStatus }));
        // Ao marcar compareceu, pergunta sobre lançamento
        if (novoStatus === 'compareceu' && !detalheEvento.lancamentoFeito) {
          setPromptLancamento(true);
        }
      }
    } catch {}
    setDetalheLoading(false);
  };

  const handleLancamentoDepois = async () => {
    setPromptLancamento(false);
    // Só fecha o prompt, lançamento ficará como pendente
  };

  const handleLancamentoJaCoberto = async () => {
    if (!detalheEvento) return;
    setPromptLancamento(false);
    await marcarLancamentoFeito(detalheEvento.id);
  };

  const handleLancamentoFeito = async () => {
    setPromptLancamento(false);
    const proc = procedimentos.find(p => p.id === detalheEvento.procedimentoId);

    // Busca o orçamento fechado mais recente desse paciente com saldo em aberto
    // (se existir) pra usar o valor negociado e o quanto já foi pago, em vez de
    // só o preço de tabela do procedimento. Orçamento não fica mais amarrado a
    // um agendamento específico — é o mesmo usado na ficha do paciente.
    let orcamento = null;
    try {
      const orcRes = await fetch(`${BASE_API_URL}/orcamentos/paciente/${detalheEvento.pacienteId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (orcRes.ok) {
        const lista = await orcRes.json();
        const abertos = (Array.isArray(lista) ? lista : [])
          .filter(o => o.status === 'fechado' && (o.saldoAberto || 0) > 0)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        orcamento = abertos[0] || null;
      }
    } catch (err) {
      console.error('Erro ao buscar orçamento do paciente:', err);
    }

    setOrcamentoData(orcamento || undefined);
    setPagamentoData({
      valorTotal: orcamento ? orcamento.valorTotal : (proc?.valorPadrao || 0),
      valorJaPago: orcamento ? orcamento.valorPago : 0,
      procedimentos: orcamento && Array.isArray(orcamento.procedimentos) && orcamento.procedimentos.length > 0
        ? orcamento.procedimentos
        : (detalheEvento.procedimentoId ? [detalheEvento.procedimentoId] : [])
    });
    setModalData(prev => ({
      ...prev,
      paciente_id: detalheEvento.pacienteId,
      procedimento_id: detalheEvento.procedimentoId,
      agendamento_id: detalheEvento.id,
    }));
    setLancamentoAgendamentoId(detalheEvento.id);
    setDetalheOpen(false);
    setPagamentoOpen(true);
  };

  const marcarLancamentoFeito = async (agId) => {
    await fetch(`${API_URL}/${agId}`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ lancamento_feito: true })
    });
    setCurrentEvents(prev => prev.map(ev =>
      ev.id === agId ? { ...ev, extendedProps: { ...ev.extendedProps, lancamento_feito: true } } : ev
    ));
    setDetalheEvento(prev => prev ? ({ ...prev, lancamentoFeito: true }) : prev);
  };

  const handleEventDrop = async ({ event, revert }) => {
    try {
      const res = await fetch(`${API_URL}/${event.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ data_hora: event.startStr })
      });
      if (!res.ok) {
        const erro = await res.json().catch(() => ({}));
        if (erro.message || erro.error) mostrarAviso(erro.message || erro.error);
        revert();
      }
    } catch {
      revert();
    }
  };

  const handleEventResize = async ({ event, revert }) => {
    try {
      const res = await fetch(`${API_URL}/${event.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ data_hora: event.startStr })
      });
      if (!res.ok) {
        const erro = await res.json().catch(() => ({}));
        if (erro.message || erro.error) mostrarAviso(erro.message || erro.error);
        revert();
      }
    } catch {
      revert();
    }
  };

  // Função para abrir modal de anamnese
  const handleAbrirAnamnese = (paciente) => {
    setPacienteAnamnese(paciente);
    setAnamneseOpen(true);
  };

  // Função para salvar anamnese (aqui só exibe, depois pode integrar com backend)
  const handleSalvarAnamnese = (respostas) => {
    console.log('Respostas da anamnese:', respostas);
  };

  return (
    <Box sx={{ backgroundColor: isDarkMode ? undefined : '#FFFAF5', minHeight: '100vh', m: 0, p: { xs: '8px', md: '20px' } }}>
      <GlobalStyles styles={{
        '.fc-button-primary': {
          backgroundColor: '#F97316 !important',
          borderColor: '#EA580C !important',
          boxShadow: 'none !important',
          fontWeight: '600 !important',
        },
        '.fc-button-primary:hover': {
          backgroundColor: '#EA580C !important',
          borderColor: '#EA580C !important',
        },
        '.fc-button-primary:not(:disabled):active, .fc-button-primary:not(:disabled).fc-button-active': {
          backgroundColor: '#C2410C !important',
          borderColor: '#C2410C !important',
        },
        '.fc-toolbar-title': {
          color: '#F97316 !important',
          fontWeight: '700 !important',
        },
        '@media (max-width:600px)': {
          '.fc-toolbar-title': {
            fontSize: '1.15em !important',
          },
          '.fc-toolbar.fc-header-toolbar, .fc-toolbar.fc-footer-toolbar': {
            flexWrap: 'wrap',
            gap: '8px',
          },
          '.fc-button': {
            padding: '4px 8px !important',
            fontSize: '0.8em !important',
          },
        },
        '.fc-col-header-cell': {
          backgroundColor: 'rgba(249,115,22,0.06) !important',
        },
        '.fc-col-header-cell-cushion': {
          color: '#F97316 !important',
          fontWeight: '700 !important',
          textTransform: 'uppercase',
          fontSize: '0.72rem !important',
          letterSpacing: '0.5px',
          textDecoration: 'none !important',
        },
        '.fc-day-today': {
          backgroundColor: 'rgba(249,115,22,0.08) !important',
        },
        '.fc-day-today .fc-daygrid-day-number': {
          color: '#F97316 !important',
          fontWeight: '700 !important',
        },
        '.fc-daygrid-event-dot': {
          borderColor: 'currentColor',
        },
        '.fc-list-event-dot': {
          borderColor: 'currentColor',
        },
        '.fc-more-link': {
          color: '#F97316 !important',
          fontWeight: '600 !important',
        },
        // Popover que abre ao clicar em "+N mais" — por padrão o FullCalendar
        // deixa isso meio transparente e sem estilo, destoando do resto da tela.
        '.fc-popover': {
          borderRadius: '12px !important',
          border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(249,115,22,0.2)'} !important`,
          backgroundColor: `${isDarkMode ? '#1e293b' : '#ffffff'} !important`,
          boxShadow: '0 8px 24px rgba(0,0,0,0.18) !important',
          overflow: 'hidden',
        },
        '.fc-popover-header': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px 12px !important',
          backgroundColor: `${isDarkMode ? 'rgba(249,115,22,0.12)' : 'rgba(249,115,22,0.08)'} !important`,
        },
        '.fc-popover-title': {
          color: '#F97316 !important',
          fontWeight: '700 !important',
          fontSize: '0.85rem',
        },
        '.fc-popover-close': {
          opacity: 0.6,
          '&:hover': { opacity: 1 },
        },
        '.fc-popover-body': {
          padding: '6px !important',
          display: 'flex',
          flexDirection: 'column',
          gap: '3px',
        },
        '.fc-popover-body .fc-daygrid-event-harness': {
          margin: '0 !important',
        },
        '.fc-popover-body .fc-event': {
          borderRadius: '6px !important',
        },
        '.fc-daygrid-day-number': {
          textDecoration: 'none !important',
          color: 'inherit',
        },
        '.fc-event-title': {
          fontWeight: '500',
        },
      }} />
      <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} mb={0.5}>
        <Typography variant="h4" fontWeight="bold" sx={{ borderLeft: '4px solid #F97316', pl: 1.5 }}>
          Calendário
        </Typography>
        {/* Filtro por dentista */}
        {dentistas.length > 1 && (
          <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
            <Box
              onClick={() => setFiltroDentista('todos')}
              sx={{
                px: 2, py: 0.6, borderRadius: '20px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                border: `1.5px solid ${filtroDentista === 'todos' ? '#F97316' : 'rgba(0,0,0,0.15)'}`,
                bgcolor: filtroDentista === 'todos' ? 'rgba(249,115,22,0.1)' : 'transparent',
                color: filtroDentista === 'todos' ? '#F97316' : 'text.secondary',
                transition: 'all 0.15s',
              }}
            >
              Todos
            </Box>
            {dentistas.map(d => (
              <Box
                key={d.id}
                onClick={() => setFiltroDentista(d.id)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 0.75,
                  px: 2, py: 0.6, borderRadius: '20px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                  border: `1.5px solid ${filtroDentista === d.id ? (d.cor || '#F97316') : 'rgba(0,0,0,0.15)'}`,
                  bgcolor: filtroDentista === d.id ? `${d.cor || '#F97316'}18` : 'transparent',
                  color: filtroDentista === d.id ? (d.cor || '#F97316') : 'text.secondary',
                  transition: 'all 0.15s',
                }}
              >
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: d.cor || '#F97316' }} />
                {d.nome}
              </Box>
            ))}
          </Box>
        )}
      </Box>
      <Typography variant="subtitle1" mb={2} sx={{ pl: 1.5 }} color="text.secondary">Calendário interativo</Typography>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={{ xs: 1, md: 0 }}>
        {/* BARRA LATERAL CALENDARIO*/}
        <Box
          flex={{ xs: '1 1 auto', md: '1 1 20%' }}
          bgcolor={isDarkMode ? theme.palette.background.paper : '#fff'}
          p={{ xs: '10px', md: '15px' }}
          borderRadius="8px"
          sx={{
            borderTop: '3px solid #F97316',
            boxShadow: '0 2px 12px rgba(249,115,22,0.08)',
            border: '1px solid rgba(249,115,22,0.15)',
            borderTopWidth: '3px',
            borderTopColor: '#F97316',
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 700, textTransform: 'uppercase', fontSize: '0.72rem', color: '#F97316', letterSpacing: '0.5px', mb: 1 }}>
            Agendamentos do dia
          </Typography>
          <List sx={{ p: 0 }}>
            {(() => {
              const hoje = new Date();
              const eventosHoje = currentEvents.filter(event => {
                const dataEvento = new Date(event.start);
                return (
                  dataEvento.getDate() === hoje.getDate() &&
                  dataEvento.getMonth() === hoje.getMonth() &&
                  dataEvento.getFullYear() === hoje.getFullYear()
                );
              });
              if (eventosHoje.length === 0) {
                return (
                  <ListItem sx={{ p: 0 }}>
                    <ListItemText primary="Nenhum agendamento para hoje." />
                  </ListItem>
                );
              }
              return eventosHoje.map((event) => {
                // Supondo que o título seja: "agendado - Procedimento - Paciente"
                const partes = event.title.split(' - ');
                const status = (partes[0] || '').toLowerCase();
                const procedimento = partes[1] || '';
                const paciente = partes[2] || '';
                let statusColor = '#F97316'; // laranja padrão
                if (status.includes('confirmado')) statusColor = '#22c55e'; // verde
                if (status.includes('cancelado') || status.includes('não vai') || status.includes('nao vai')) statusColor = '#ef4444'; // vermelho
                return (
                  <ListItem
                    key={event.id}
                    disableGutters
                    sx={{
                      mb: 1.5,
                      p: 0,
                      borderRadius: 2,
                      bgcolor: theme => theme.palette.mode === 'dark' ? '#232a36' : '#FFF7ED',
                      border: `1px solid rgba(249,115,22,0.18)`,
                      display: 'flex',
                      alignItems: 'stretch',
                      transition: 'box-shadow 0.2s',
                      '&:hover': { boxShadow: '0 2px 8px rgba(249,115,22,0.15)' }
                    }}
                  >
                    <Box sx={{ width: 4, borderRadius: '8px 0 0 8px', bgcolor: statusColor, flexShrink: 0 }} />
                    <Box sx={{ p: 1.5, flex: 1 }}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5, color: statusColor }}>
                        {paciente || event.title}
                      </Typography>
                      {procedimento && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                          {procedimento}
                        </Typography>
                      )}
                      <Typography variant="caption" color="text.disabled">
                        {formatDate(event.start, {
                          year: "numeric",
                          month: "short",
                          day: "numeric"
                        })}
                      </Typography>
                    </Box>
                  </ListItem>
                );
              });
            })()}
          </List>
        </Box>
        {/* CALENDARIO */}
        <Box flex="1 1 100%" ml={{ xs: 0, md: '15px' }} sx={{ bgcolor: isDarkMode ? undefined : '#fff', borderRadius: '8px', p: { xs: 1, md: 2 }, minWidth: 0, boxShadow: '0 2px 12px rgba(249,115,22,0.06)', border: '1px solid rgba(249,115,22,0.12)' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
            {googleAviso && (
              <Alert severity={googleAviso.startsWith('Erro') || googleAviso.startsWith('Não foi possível') ? 'error' : 'success'} sx={{ py: 0, mr: 'auto' }}>
                {googleAviso}
              </Alert>
            )}
            {googleConectado === null ? null : googleConectado ? (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={sincronizandoGoogle ? <CircularProgress size={16} /> : <SyncRoundedIcon />}
                  onClick={handleSincronizarGoogle}
                  disabled={sincronizandoGoogle}
                  sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
                >
                  Sincronizar
                </Button>
                <Chip
                  icon={<GoogleIcon sx={{ fontSize: '16px !important' }} />}
                  label="Google Calendar conectado"
                  color="success"
                  variant="outlined"
                  onDelete={googleCarregando ? undefined : handleDesconectarGoogle}
                  deleteIcon={googleCarregando ? <CircularProgress size={14} /> : <LinkOffRoundedIcon titleAccess="Desconectar" />}
                  sx={{ fontWeight: 600 }}
                />
              </>
            ) : (
              <Button
                size="small"
                variant="outlined"
                startIcon={googleCarregando ? <CircularProgress size={16} /> : <GoogleIcon />}
                onClick={handleConectarGoogle}
                disabled={googleCarregando}
                sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
              >
                Conectar Google Calendar
              </Button>
            )}
          </Box>
          <FullCalendar
            ref={calendarRef}
            height="auto"
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              listPlugin
            ]}
            headerToolbar={isMobile ? {
              left: "prev,next",
              center: "title",
              right: "today"
            } : {
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth"
            }}
            footerToolbar={isMobile ? {
              left: "",
              center: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
              right: ""
            } : false}
            timeZone="UTC"
            initialView="dayGridMonth"
            editable={true}
            dayMaxEvents={2}
            dateClick={handleDateClick}
            eventClick={handleEventClick}
            eventDrop={handleEventDrop}
            eventResize={handleEventResize}
            eventContent={renderEventContent}
            events={(() => {
              const bloqueiosEvents = bloqueios.map(b => ({
                id: `bloqueio-${b.id}`,
                title: `Bloqueado${b.motivo ? ' - ' + b.motivo : ''}`,
                start: b.dataInicio,
                end: b.dataFim,
                allDay: !!b.diaTodo,
                editable: false,
                backgroundColor: '#94a3b8',
                borderColor: '#64748b',
                textColor: '#fff',
                extendedProps: { bloqueio: true, bloqueioId: b.id, motivo: b.motivo, user_id: b.userId },
              }));
              const todos = [...currentEvents, ...eventosGoogleExternos, ...bloqueiosEvents];
              return filtroDentista === 'todos' ? todos : todos.filter(ev => ev.extendedProps?.user_id === filtroDentista);
            })()}
            locales={[ptBrLocale]}
            locale="pt-br"
          />
        </Box>
      </Box>
      {/* Novo Modal de Agendamento visual */}
      <ModalAgendamento
        open={modalOpen}
        onClose={handleModalClose}
        pacientes={pacientes}
        procedimentos={procedimentos}
        dentistas={dentistas}
        dataDefault={modalData.data}
        horaDefault={modalData.hora}
        pacienteDefault={modalData.paciente_id}
        procedimentoDefault={
          Array.isArray(modalData.procedimentos) && modalData.procedimentos.length
            ? modalData.procedimentos
            : (Array.isArray(modalData.procedimento_id) ? modalData.procedimento_id : (modalData.procedimento_id ? [modalData.procedimento_id] : []))
        }
        dentistaDefault={modalData.user_id || ''}
        duracaoDefault={minutosParaDuracaoStr(modalData.duracao_minutos)}
        observacaoDefault={modalData.observacoes || ''}
        modoEdicao={!!editandoId}
        onBloquear={handleCriarBloqueio}
        onSave={async (dados) => {
          if (!dados.paciente_id) {
            alert('Selecione um paciente antes de salvar!');
            return;
          }
          const usuarioLogado = JSON.parse(localStorage.getItem('user'));
          const duracaoMinutos = dados.duracao === '1h 00min' ? 60 : dados.duracao === '1h 30min' ? 90 : dados.duracao === '2h 00min' ? 120 : 30;
          const userIdFinal = dados.user_id || usuarioLogado?.id;
          const procedimentosFinal = (dados.procedimentos || []).filter(Boolean);
          if (procedimentosFinal.length === 0) {
            mostrarAviso('Selecione pelo menos um procedimento para agendar.', 'Procedimento obrigatório');
            return;
          }
          const procedimentoIdFinal = procedimentosFinal[0];
          const nomesProcedimentosFinal = procedimentosFinal.map(pid => procedimentos.find(p => p.id === pid)?.nome).filter(Boolean).join(', ');
          const dataHoraFinal = dados.data ? `${dados.data}T${dados.hora || '08:00'}` : '';

          if (editandoId) {
            // Modo edição — PUT no agendamento existente
            try {
              const res = await fetch(`${API_URL}/${editandoId}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify({
                  paciente_id: dados.paciente_id,
                  procedimento_id: procedimentoIdFinal,
                  procedimentos: procedimentosFinal,
                  data_hora: dataHoraFinal,
                  duracao_minutos: duracaoMinutos,
                  observacoes: dados.observacao || '',
                  user_id: userIdFinal,
                })
              });
              if (res.ok) {
                const dentistaEvento = dentistas.find(d => d.id === userIdFinal);
                const corEvento = dentistaEvento?.cor || null;
                const pacienteNomeEvento = pacientes.find(p => p.id === dados.paciente_id)?.nome || '';
                setCurrentEvents(prev => prev.map(ev => ev.id !== editandoId ? ev : {
                  ...ev,
                  title: `${pacienteNomeEvento}${nomesProcedimentosFinal ? ' - ' + nomesProcedimentosFinal : ''}`,
                  start: dataHoraFinal,
                  end: dataHoraFinal,
                  backgroundColor: corEvento || undefined,
                  borderColor: corEvento || undefined,
                  extendedProps: {
                    ...ev.extendedProps,
                    paciente_id: dados.paciente_id,
                    procedimento_id: procedimentoIdFinal,
                    procedimentos: procedimentosFinal,
                    procedimento_nome: nomesProcedimentosFinal,
                    duracao_minutos: duracaoMinutos,
                    observacoes: dados.observacao || '',
                    user_id: userIdFinal,
                    cor_dentista: corEvento,
                    nome_dentista: dentistaEvento?.nome || ev.extendedProps?.nome_dentista || '',
                  }
                }));
                setModalOpen(false);
                setEditandoId(null);
              } else {
                const erro = await res.json().catch(() => ({}));
                mostrarAviso(erro.message || erro.error || "Erro ao salvar alterações!");
              }
            } catch (err) {
              mostrarAviso("Erro de conexão com o backend!");
            }
            return;
          }

          // Modo criação — POST de um agendamento novo
          const novoAgendamento = {
            clinica_id: usuarioLogado?.clinicaId || "1",
            user_id: userIdFinal,
            paciente_id: dados.paciente_id,
            procedimento_id: procedimentoIdFinal,
            procedimentos: procedimentosFinal,
            data_hora: dataHoraFinal,
            duracao_minutos: duracaoMinutos,
            status: "agendado",
            observacoes: dados.observacao || '',
            orcamento_id: orcamentoIdPendente || null
          };
          try {
            const res = await fetch(API_URL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
              },
              body: JSON.stringify(novoAgendamento)
            });
            if (res.ok) {
              const agendamentoSalvo = await res.json();
              const dentistaEvento = dentistas.find(d => d.id === novoAgendamento.user_id);
              const corEvento = dentistaEvento?.cor || null;
              const idsProcedimentosSalvos = Array.isArray(agendamentoSalvo.procedimentos) && agendamentoSalvo.procedimentos.length
                ? agendamentoSalvo.procedimentos
                : (agendamentoSalvo.procedimento_id ? [agendamentoSalvo.procedimento_id] : []);
              const procedimentoNome = idsProcedimentosSalvos.map(pid => procedimentos.find(p => p.id === pid)?.nome).filter(Boolean).join(', ');
              const pacienteNomeEvento = pacientes.find(p => p.id === agendamentoSalvo.paciente_id)?.nome || '';
              setCurrentEvents(prev => ([
                ...prev,
                {
                  id: agendamentoSalvo.id,
                  title: `${pacienteNomeEvento ? pacienteNomeEvento + (procedimentoNome ? ' - ' + procedimentoNome : '') : agendamentoSalvo.status + (procedimentoNome ? ' - ' + procedimentoNome : '')}`,
                  start: agendamentoSalvo.data_hora,
                  end: agendamentoSalvo.data_hora,
                  allDay: false,
                  backgroundColor: corEvento || undefined,
                  borderColor: corEvento || undefined,
                  extendedProps: {
                    paciente_id: agendamentoSalvo.paciente_id,
                    procedimento_id: agendamentoSalvo.procedimento_id,
                    procedimentos: idsProcedimentosSalvos,
                    procedimento_nome: procedimentoNome,
                    duracao_minutos: agendamentoSalvo.duracao_minutos,
                    observacoes: agendamentoSalvo.observacoes,
                    status: agendamentoSalvo.status,
                    user_id: novoAgendamento.user_id,
                    cor_dentista: corEvento,
                    nome_dentista: dentistaEvento?.nome || '',
                  }
                }
              ]));
              setModalOpen(false);
              setOrcamentoIdPendente(null);
            } else {
              const erro = await res.json().catch(() => ({}));
              mostrarAviso(erro.message || erro.error || "Erro ao salvar agendamento!");
            }
          } catch (err) {
            mostrarAviso("Erro de conexão com o backend!");
          }
        }}
      />

      {/* Modal de Pagamento */}
      <ModalPagamento
        open={pagamentoOpen}
        onClose={() => setPagamentoOpen(false)}
        tipoUsuario={tipoUsuario}
        valorTotal={pagamentoData?.valorTotal}
        valorJaPago={pagamentoData?.valorJaPago || 0}
        onSave={async data => {
          // Busca dados do paciente
          const usuarioLogado = JSON.parse(localStorage.getItem('user'));
          const paciente = pacientes.find(p => p.id === modalData.paciente_id);

          // Busca procedimentos do orçamento fechado
          let procedimentosOrcamento = [];
          if (orcamentoData && orcamentoData.status === 'fechado' && Array.isArray(orcamentoData.procedimentos)) {
            procedimentosOrcamento = orcamentoData.procedimentos;
          } else if (modalData.procedimento_id) {
            procedimentosOrcamento = [modalData.procedimento_id];
          }

          // Mapeamento das formas de pagamento para o ENUM do backend
          const formaPagamentoMap = {
            dinheiro: 'Dinheiro',
            cartao: 'Cartão de Crédito',
            debito: 'Cartão de Débito',
            pix: 'PIX',
            boleto: 'Outros',
            outro: 'Outros'
          };
          const procedimento = procedimentos.find(p => p.id === procedimentosOrcamento[0]);
          const nomesProcedimentosOrcamento = procedimentosOrcamento
            .map(pid => procedimentos.find(p => p.id === pid)?.nome)
            .filter(Boolean);
          const descricaoPagamento = nomesProcedimentosOrcamento.length
            ? nomesProcedimentosOrcamento.join(', ')
            : 'Pagamento de procedimento';

          // Se ainda não existe um orçamento formal pra esse agendamento e o valor pago
          // agora é menor que o valor total do procedimento, cria o orçamento na hora —
          // é isso que faz o saldo em aberto aparecer na ficha do paciente pra completar depois.
          let orcamentoId = orcamentoData?.id || null;
          const valorTotalProcedimento = pagamentoData?.valorTotal || 0;
          if (!orcamentoId && paciente && valorTotalProcedimento > 0 && data.valor < valorTotalProcedimento) {
            try {
              const chave = procedimento?.id || 'avulso';
              const res = await fetch(`${BASE_API_URL}/orcamentos`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({
                  agendamento_id: modalData.agendamento_id || null,
                  paciente_id: paciente.id,
                  status: 'fechado',
                  procedimentos: procedimentosOrcamento,
                  valores: { [chave]: valorTotalProcedimento },
                }),
              });
              const orcCriado = await res.json().catch(() => null);
              if (res.ok && orcCriado?.id) orcamentoId = orcCriado.id;
            } catch (err) {
              console.error('Erro ao criar orçamento automático para saldo em aberto:', err);
            }
          }

          const payload = {
            descricao: descricaoPagamento,
            valor: data.valor,
            data: new Date().toISOString().slice(0, 10),
            formaPagamento: formaPagamentoMap[data.forma] || 'Dinheiro',
            paciente: paciente ? paciente.nome : '',
            cpf: paciente ? (paciente.cpfCnpj || paciente.cpf_cnpj || paciente.cpf || '') : '',
            procedimento: procedimento ? procedimento.nome : '',
            tipoPessoa: data.tipoPessoa || tipoUsuario,
            observacoes: data.observacoes,
            pacienteId: paciente ? paciente.id : null,
            procedimentoId: procedimento ? procedimento.id : null,
            userId: usuarioLogado?.id,
            orcamentoId,
            ...(data.maquinaCartaoId && {
              maquinaCartaoId: data.maquinaCartaoId,
              parcelasCartao: data.parcelasCartao,
              bandeiraCartao: data.bandeiraCartao,
              cartaoAntecipado: data.cartaoAntecipado,
              taxaCartaoResponsavel: data.taxaCartaoResponsavel,
            }),
          };
          try {
            await criarFaturamento(payload);
            setPagamentoOpen(false);
            if (lancamentoAgendamentoId) {
              await marcarLancamentoFeito(lancamentoAgendamentoId);
              setLancamentoAgendamentoId(null);
            }
          } catch (err) {
            alert('Erro ao registrar pagamento/faturamento!');
          }
        }}
      />


      <ModalAnamnese
        open={anamneseOpen}
        onClose={() => setAnamneseOpen(false)}
        onSave={handleSalvarAnamnese}
        paciente={pacienteAnamnese}
      />

      {/* Prompt: lançar faturamento agora ou depois */}
      <Dialog open={promptLancamento} onClose={handleLancamentoDepois} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: '#fff7ed', border: '2px solid #fed7aa', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
            <WarningAmberIcon sx={{ color: '#f97316', fontSize: 28 }} />
          </Box>
          <Typography variant="h6" fontWeight={700} mb={0.5}>Registrar faturamento?</Typography>
          <Typography fontSize={13} color="text.secondary" mb={3}>
            O paciente <strong>{detalheEvento?.paciente?.nome}</strong> compareceu. Deseja lançar o faturamento agora?
          </Typography>
          <Box display="flex" gap={1.5}>
            <Button
              fullWidth variant="outlined"
              onClick={handleLancamentoDepois}
              sx={{ borderRadius: 3, py: 1.2, fontWeight: 600 }}
            >
              Depois
            </Button>
            <Button
              fullWidth variant="contained"
              onClick={handleLancamentoFeito}
              sx={{ borderRadius: 3, py: 1.2, fontWeight: 700, bgcolor: '#f97316', '&:hover': { bgcolor: '#ea580c' } }}
            >
              Lançar agora
            </Button>
          </Box>
          <Button
            fullWidth
            onClick={handleLancamentoJaCoberto}
            sx={{ mt: 1.5, borderRadius: 3, py: 0.8, fontWeight: 600, fontSize: 12.5, color: 'text.secondary' }}
          >
            Já foi pago — mesmo tratamento, outra sessão
          </Button>
        </Box>
      </Dialog>

      {/* Modal de detalhes do agendamento */}
      <Dialog
        open={detalheOpen}
        onClose={() => setDetalheOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: 'hidden',
            background: theme.palette.mode === 'dark' ? '#0f172a' : '#fff',
          }
        }}
      >
        {(() => {
          const ev = detalheEvento;
          if (!ev) return null;
          const temTelefone = !!ev.paciente?.telefone;
          const status = ev.status || 'pendente';
          const dataHora = ev.start ? new Date(ev.start) : null;

          const whatsappLink = temTelefone
            ? `https://wa.me/55${ev.paciente.telefone.replace(/\D/g, '')}?text=${encodeURIComponent(
                `Olá ${ev.paciente?.nome || ''}! 😊 Lembramos que você tem uma consulta agendada${dataHora ? ` para ${dataHora.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', timeZone: 'UTC' })} às ${dataHora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })}` : ''}. Você confirma presença? Responda *Sim* ou *Não*.`
              )}`
            : null;

          const statusConfig = {
            confirmado:  { label: 'Confirmado pelo paciente', color: '#22c55e', bg: '#f0fdf4', icon: <CheckCircleOutlineIcon sx={{ color: '#fff', fontSize: 20 }} /> },
            cancelado:   { label: 'Cancelado pelo paciente',  color: '#ef4444', bg: '#fef2f2', icon: <CancelOutlinedIcon sx={{ color: '#fff', fontSize: 20 }} /> },
            compareceu:  { label: 'Paciente compareceu',      color: '#3b82f6', bg: '#eff6ff', icon: <CheckCircleOutlineIcon sx={{ color: '#fff', fontSize: 20 }} /> },
            pendente:    { label: 'Aguardando confirmação',    color: '#f59e0b', bg: '#fffbeb', icon: <HourglassEmptyIcon sx={{ color: '#fff', fontSize: 20 }} /> },
          };
          const sc = statusConfig[status] || statusConfig.pendente;

          const cardBg = theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f8fafc';
          const borderColor = theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : '#e2e8f0';

          return (
            <>
              {/* Header */}
              <Box sx={{ background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)', p: 3, pb: 2.5, position: 'relative' }}>
                <Button onClick={() => setDetalheOpen(false)} sx={{ position: 'absolute', top: 12, right: 12, minWidth: 0, p: 0.5, color: 'rgba(255,255,255,0.7)', borderRadius: 2, '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.15)' } }}><CloseIcon fontSize="small" /></Button>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', fontSize: 10 }}>
                  Agendamento
                </Typography>
                <Typography variant="h6" fontWeight={800} sx={{ color: '#fff', mt: 0.25, lineHeight: 1.2 }}>
                  {ev.paciente?.nome || 'Paciente não identificado'}
                </Typography>

                {/* Data/hora resumida no header */}
                {dataHora && (
                  <Box display="flex" gap={1.5} mt={1.5} flexWrap="wrap">
                    <Box sx={{ bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2, px: 1.5, py: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <CalendarTodayIcon sx={{ color: '#fff', fontSize: 14 }} />
                      <Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>
                        {dataHora.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short', timeZone: 'UTC' })}
                      </Typography>
                    </Box>
                    <Box sx={{ bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2, px: 1.5, py: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <AccessTimeIcon sx={{ color: '#fff', fontSize: 14 }} />
                      <Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>
                        {dataHora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })}
                      </Typography>
                    </Box>
                    {ev.duracao && (
                      <Box sx={{ bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2, px: 1.5, py: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <TimerIcon sx={{ color: '#fff', fontSize: 14 }} />
                        <Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{ev.duracao}min</Typography>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>

              <DialogContent sx={{ p: 0 }}>
                {/* Status do WhatsApp / confirmação */}
                <Box sx={{ mx: 2.5, mt: 2.5, p: 2, borderRadius: 3, bgcolor: theme.palette.mode === 'dark' ? `${sc.color}18` : sc.bg, border: `1.5px solid ${sc.color}40` }}>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Box sx={{ width: 36, height: 36, borderRadius: '50%', bgcolor: sc.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {sc.icon}
                    </Box>
                    <Box>
                      <Typography fontWeight={700} fontSize={14} sx={{ color: sc.color }}>{sc.label}</Typography>
                      <Typography fontSize={12} color="text.secondary">
                        {status === 'confirmado' && 'Paciente respondeu SIM pelo WhatsApp'}
                        {status === 'cancelado' && 'Paciente respondeu NÃO pelo WhatsApp'}
                        {status === 'compareceu' && 'Marcado manualmente pela clínica'}
                        {status === 'pendente' && (temTelefone ? 'Mensagem enviada, aguardando resposta' : 'Paciente sem telefone — mensagem não enviada')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Alerta sem telefone */}
                {!temTelefone && (
                  <Box sx={{ mx: 2.5, mt: 1.5, p: 1.5, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? 'rgba(239,68,68,0.1)' : '#fef2f2', border: '1px solid #fca5a5', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningAmberIcon sx={{ color: '#dc2626', fontSize: 18, flexShrink: 0 }} />
                    <Typography fontSize={12} sx={{ color: '#dc2626', fontWeight: 600 }}>
                      Sem telefone cadastrado — não é possível enviar confirmação via WhatsApp
                    </Typography>
                  </Box>
                )}

                {/* Dados do paciente */}
                <Box sx={{ mx: 2.5, mt: 2, p: 2, borderRadius: 3, bgcolor: cardBg, border: `1px solid ${borderColor}` }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Box display="flex" alignItems="center" gap={0.75}>
                      <PersonIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                      <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>Paciente</Typography>
                    </Box>
                    {ev.pacienteId && (
                      <Button
                        size="small"
                        onClick={() => navigate(`/pacientes/${ev.pacienteId}`)}
                        sx={{ fontSize: 11, fontWeight: 700, color: '#F97316', minWidth: 0, py: 0.25, px: 1, textTransform: 'none' }}
                      >
                        Ver Ficha
                      </Button>
                    )}
                  </Box>
                  <Box display="flex" flexDirection="column" gap={0.75}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <PhoneIcon sx={{ fontSize: 15, color: temTelefone ? 'text.secondary' : 'text.disabled' }} />
                      <Typography fontSize={13} color={temTelefone ? 'text.primary' : 'text.disabled'}>
                        {temTelefone ? ev.paciente.telefone : 'Sem telefone'}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <EmailIcon sx={{ fontSize: 15, color: ev.paciente?.email ? 'text.secondary' : 'text.disabled' }} />
                      <Typography fontSize={13} color={ev.paciente?.email ? 'text.primary' : 'text.disabled'}>
                        {ev.paciente?.email || 'Sem e-mail'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Dentista responsável */}
                {ev.nomeDentista && (
                  <Box sx={{ mx: 2.5, mt: 1.5, p: 2, borderRadius: 3, bgcolor: cardBg, border: `1px solid ${borderColor}` }}>
                    <Box display="flex" alignItems="center" gap={0.75} mb={0.75}>
                      <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: ev.corDentista || '#F97316', flexShrink: 0 }} />
                      <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>Dentista Responsável</Typography>
                    </Box>
                    <Typography fontSize={13} fontWeight={600}>{ev.nomeDentista}</Typography>
                  </Box>
                )}

                {/* Observações */}
                {ev.observacoes && (
                  <Box sx={{ mx: 2.5, mt: 1.5, p: 2, borderRadius: 3, bgcolor: cardBg, border: `1px solid ${borderColor}` }}>
                    <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 0.5 }}>Observações</Typography>
                    <Typography fontSize={13}>{ev.observacoes}</Typography>
                  </Box>
                )}

                {/* Ação manual: só Compareceu */}
                <Box sx={{ mx: 2.5, mt: 2 }}>
                  <Typography fontSize={11} fontWeight={700} color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1, mb: 1 }}>Ação da clínica</Typography>
                  <Button
                    fullWidth
                    variant={status === 'compareceu' ? 'contained' : 'outlined'}
                    onClick={() => handleDetalheStatus(status === 'compareceu' ? 'pendente' : 'compareceu')}
                    disabled={detalheLoading}
                    sx={{
                      borderRadius: 3, py: 1.2, fontWeight: 700, fontSize: 14,
                      borderColor: '#3b82f6', color: status === 'compareceu' ? '#fff' : '#3b82f6',
                      bgcolor: status === 'compareceu' ? '#3b82f6' : 'transparent',
                      '&:hover': { bgcolor: '#3b82f6', color: '#fff' }
                    }}
                  >
                    <CheckCircleOutlineIcon sx={{ mr: 0.75, fontSize: 18 }} />
                    {status === 'compareceu' ? 'Compareceu (desfazer)' : 'Marcar como Compareceu'}
                  </Button>
                </Box>

                {/* Status do lançamento — só aparece se compareceu */}
                {status === 'compareceu' && (
                  <Box sx={{ mx: 2.5, mt: 1.5, mb: 2.5 }}>
                    {ev.lancamentoFeito ? (
                      <Box sx={{ p: 1.5, borderRadius: 3, bgcolor: theme.palette.mode === 'dark' ? 'rgba(34,197,94,0.1)' : '#f0fdf4', border: '1.5px solid #86efac', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CheckCircleOutlineIcon sx={{ color: '#22c55e', fontSize: 18 }} />
                        <Box>
                          <Typography fontSize={13} fontWeight={700} sx={{ color: '#16a34a' }}>Lançamento realizado</Typography>
                          <Typography fontSize={11} color="text.secondary">Faturamento já foi registrado</Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ p: 1.5, borderRadius: 3, bgcolor: theme.palette.mode === 'dark' ? 'rgba(245,158,11,0.1)' : '#fffbeb', border: '1.5px solid #fcd34d', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <WarningAmberIcon sx={{ color: '#d97706', fontSize: 18, flexShrink: 0 }} />
                          <Box>
                            <Typography fontSize={13} fontWeight={700} sx={{ color: '#92400e' }}>Lançamento pendente</Typography>
                            <Typography fontSize={11} color="text.secondary">Faturamento ainda não registrado</Typography>
                          </Box>
                        </Box>
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => setPromptLancamento(true)}
                          sx={{ bgcolor: '#f59e0b', color: '#fff', borderRadius: 2, fontWeight: 700, fontSize: 11, whiteSpace: 'nowrap', '&:hover': { bgcolor: '#d97706' } }}
                        >
                          Lançar agora
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
                {status !== 'compareceu' && <Box mb={2.5} />}
              </DialogContent>

              <DialogActions sx={{ px: 2.5, pb: 2.5, pt: 0, gap: 1 }}>
                {whatsappLink && (
                  <Button
                    component="a"
                    href={whatsappLink}
                    target="_blank"
                    variant="contained"
                    fullWidth
                    size="small"
                    sx={{ bgcolor: '#25d366', color: '#fff', borderRadius: 2.5, py: 0.7, fontWeight: 700, fontSize: 12.5, gap: 0.75, '&:hover': { bgcolor: '#128c7e' } }}
                  >
                    <WhatsAppIcon sx={{ fontSize: 16 }} /> Enviar lembrete
                  </Button>
                )}
                <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    size="small"
                    onClick={handleAbrirEdicao}
                    disabled={detalheLoading}
                    sx={{ borderRadius: 2.5, py: 0.7, fontWeight: 700, fontSize: 12.5, color: '#F97316', borderColor: 'rgba(249,115,22,0.4)', '&:hover': { borderColor: '#F97316', bgcolor: 'rgba(249,115,22,0.06)' } }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    fullWidth
                    size="small"
                    onClick={handleDetalheExcluir}
                    disabled={detalheLoading}
                    sx={{ borderRadius: 2.5, py: 0.7, fontWeight: 700, fontSize: 12.5 }}
                  >
                    Excluir
                  </Button>
                </Box>
              </DialogActions>
            </>
          );
        })()}
      </Dialog>

      {/* Confirmação de desbloqueio */}
      <Dialog
        open={!!confirmDesbloqueio}
        onClose={() => setConfirmDesbloqueio(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogContent sx={{ p: 3, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: 'rgba(100,116,139,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <LockOpenOutlinedIcon sx={{ color: '#64748b', fontSize: 20 }} />
            </Box>
            <Typography variant="h6" fontWeight={700} fontSize="1.05rem">Desbloquear horário?</Typography>
          </Box>
          {confirmDesbloqueio && (
            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#f8fafc', border: '1px solid rgba(0,0,0,0.06)' }}>
              <Typography fontSize="0.85rem" fontWeight={700}>
                {formatarPeriodoBloqueio(confirmDesbloqueio)}
              </Typography>
              {confirmDesbloqueio.motivo && (
                <Typography fontSize="0.8rem" color="text.secondary">{confirmDesbloqueio.motivo}</Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5 }}>
          <Button onClick={() => setConfirmDesbloqueio(null)} sx={{ color: 'text.secondary', fontWeight: 600 }}>
            Cancelar
          </Button>
          <Box sx={{ flex: 1 }} />
          <Button
            onClick={handleConfirmarDesbloqueio}
            variant="contained"
            sx={{ bgcolor: '#64748b', '&:hover': { bgcolor: '#475569' }, borderRadius: 2, fontWeight: 700 }}
          >
            Desbloquear
          </Button>
        </DialogActions>
      </Dialog>

      {/* Aviso genérico (substitui window.alert) */}
      <Dialog
        open={avisoDialog.open}
        onClose={() => setAvisoDialog(prev => ({ ...prev, open: false }))}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4 } }}
      >
        <DialogContent sx={{ p: 3, pb: 1 }}>
          <Typography variant="h6" fontWeight={700} fontSize="1.05rem" sx={{ mb: 1 }}>
            {avisoDialog.titulo}
          </Typography>
          <Typography fontSize="0.88rem" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
            {avisoDialog.mensagem}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5 }}>
          <Button
            onClick={() => setAvisoDialog(prev => ({ ...prev, open: false }))}
            variant="contained"
            fullWidth
            sx={{ bgcolor: '#F97316', '&:hover': { bgcolor: '#EA580C' }, borderRadius: 2, fontWeight: 700 }}
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Calendar;
